import { render, staticRenderFns } from "./Groups.tab.vue?vue&type=template&id=ff3f7bf6&"
import script from "./Groups.tab.vue?vue&type=script&lang=ts&"
export * from "./Groups.tab.vue?vue&type=script&lang=ts&"
import style0 from "./Groups.tab.vue?vue&type=style&index=0&lang=css&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports